import {queryClient} from "@app/appProvider/queryClient/queryClient";
import {
	QUERY_KEY_TRACKABLE_OBJECTS_SINGLE_VOYAGES
} from "@containers/singleVoyage/trackableObjects/queryHooks/constants/queryKey";

export const refetchTrackableObjects = () => {
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_TRACKABLE_OBJECTS_SINGLE_VOYAGES]});
}